<template>
  <div class="animated-wishlist-button__wrapper">
    <div
      class="animated-wishlist-button"
      v-html="wishlistComment"
    />

    <div class="animated-wishlist-button wishlist-static">
      <button
        type="button"
        class="btn btn-wishlist-heart"
      >
        <label>
          <icon-wishlist />
          <icon-wishlistselected />
        </label>
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Animated wishlist button (animated-wishlist-button)
 * -----------------------------------------------------------------------------
 * Animated Wishlist button.
 *
 */
import IconWishlist from '~icons/misc/wishlist.svg'
import IconWishlistselected from '~icons/misc/wishlist-selected.svg'

export default {
  name: 'AnimatedWishlistButton',

  components: {
    IconWishlist,
    IconWishlistselected,
  },

  props: {
    productId: {
      type: [Number, Boolean],
      default: false,
    },
  },

  computed: {
    wishlistComment() {
      return ` <!-- include 'wishlist-button-product' with '${this.productId}'-->`
    },
  },
}
</script>

<style lang="scss">
@import './animated-wishlist-button';
</style>
